// extracted by mini-css-extract-plugin
export default {"hashtag":"HashtagHighlighter_hashtag__xteui"};